module.exports = __webpack_public_path__ + "img/icon-borrow-egt-usdt.32b41e86.svg";